import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PageContainer from '../../../../components/Container/pageContainer'
import { Box, Grid, Tab, Tabs, Typography } from '@mui/material'
import CustomForm from '../../../../components/form/form'
import { Main } from '../../../../constant'
import { CustomBtn } from '../../../../components/button/button'
import SuggestionInput from '../../../../components/suggestionInput/suggestionInput'
import { Date } from '../../../../components/Date/Date'
import dayjs from 'dayjs'
import CustomTable from '../../../../components/table/SimpleTable'
import { Input } from '../../../../components/input/input'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { FullDate } from '../../../../components/Date/FullDate'
import { PostRequest } from '../../../../redux/actions/PostRequest'
import { CustomSelect } from '../../../../components/select/select'
import StudentDetailsComp from './studentDetails'
import { ShowLoader } from '../../../../redux/actions/loader'
import { TabPanel, TabContext } from '@mui/lab';
import ShowClass from '../../Attendance/studentAttendance/components/showClass';
import { DateGlobalConvertor } from '../../../../components/Date/DateGlobalConverter'
import { debounce } from 'lodash';
import EnrollStudent from './enrollStudent'
import ReceiveFees from './receiveFees'
import StopTransport from './stopTransport'
import FormTable from '../../StudentStatus/components/table'
import AllTransport from './allTransportStudents'
import DefaulterTransportStudents from './allTransportStudents'

const TransportAddRemove = (props) => {
  const [data, setData] = useState(Main().Fee);
  const [getfilterdata, setGetfilterdata] = useState(data.inputs.filter((item) => item.feildtype !== 'label'));
  const [initialInputValues, setInitialInputValues] = useState(Object.fromEntries(
    getfilterdata
      .map((item) => [item.name, ''])
  ));
  const [currentTab, setCurrentTab] = useState(0); // State variable to control the current tab
  const [suggestions, setSuggestions] = useState();
  const dispatch = useDispatch();
  const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
  const url = useSelector((state) => state.Api);
  const [update, setUpdate] = useState(0);
  const [studentOldDetails, setStudentOldDetails] = useState()
  const [maxSelectableDate, setMaxSelectableDate] = useState();
  const [recordInserted, setRecordInserted] = useState(false);
  const [feesForMonth, setFeesFormMonth] = useState(0);
  const [numberOfDays, setNumberOfDays] = useState(0);
  const [feesForNumberOfDays, setFeesForNumberOfDays] = useState(0);
  const [amount, setAmount] = useState('');
  const [feesPay, setFeesPay] = useState('');
  const [currentPayment, setCurrentPayment] = useState(0);
  const showlatefee = useSelector((state) => state.Api.showlatefee);
  const [dues, setDues] = useState(0);
  const [value, setValue] = React.useState(0);

  const [inputValues, setInputValues] = useState({ Date: dayjs().format('MMMM YYYY'), ...initialInputValues });

  const fetchstudent = (param) => {
    dispatch(ShowLoader('1'))
    axios.post(url.transport, param, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          //   res.data.StudentDetails.feesPage=true
          // //console.log(res.data)
          // //console.log(res.data?.status)
          let dues = res.data?.result?.reduce((acc, item) => acc + item.Fees, 0) || 0;
          let paid = res.data?.result?.reduce((acc, item) => acc + item.paidFees, 0) || 0;
          res.data.status.dues = dues
          res.data.status.paid = paid
          const getDues = dues-paid
          setDues(getDues)
          setStudentOldDetails(res.data);
          //console.log(res.data);
          // studentOldDetails.dues = (getDues)
          // //console.log(getDues)
          setMaxSelectableDate(dayjs(res.data.lastrecord))
          // setTimeout(()=>{
          dispatch(ShowLoader('0'))
          // },1000)
        }
      })
      .catch((err) => {
        dispatch(ShowLoader('0'))
        //console.error(err); // Log the error response for debugging
      });
  }
  useEffect(() => {
    // console.log()
    try {
      axios.get(url.studentsuggestion, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            //console.log(res.data.message);
            setSuggestions(res.data.message);
          }
        })
        .catch((err) => {
          //console.error(err); // Log the error response for debugging
        });
    } catch (err) {
      //console.error(err);
    }
  }, [update]);



  function suggestionhandleInputChange(e) {
    setRecordInserted(false)
    setFeesForNumberOfDays(0)
    setStudentOldDetails('')
    //console.log(e.target.name, e.target.value)
    setInputValues((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.value,
      Ammount: '',
    }));
    const RollNum = { RollNum: e.target.value }
    fetchstudent(RollNum)
  }
 
  const calculateFees = () => {
    const timestamp = window.Date.now(); // You can also just use Date.now()
    const currentDate = dayjs(timestamp); // Use dayjs to get the current date
    let feesForDays = 0;
    const daysInCurrentMonth = currentDate.daysInMonth();

    if (inputValues.DateFrom) { // Check if DateFrom is falsy (undefined or empty)
      const startDate = parseInt(inputValues.DateFrom.split('-')[2], 10);
      const remainingDays = daysInCurrentMonth - (startDate - 1);
      feesForDays = (amount / daysInCurrentMonth) * remainingDays;
      setNumberOfDays(remainingDays);
    } else {
      const remainingDays = daysInCurrentMonth - currentDate.date();
      feesForDays = (amount / daysInCurrentMonth) * remainingDays;
      // If you need to set the number of days for the current date, uncomment the line below
      setNumberOfDays(remainingDays);
    }

    // Ensure you're only setting state when necessary to avoid loops
    setFeesForNumberOfDays(feesForDays.toFixed(2));
    setFeesFormMonth(currentDate.month() + 1);

  }

  useEffect(() => {
    calculateFees()
  }, [amount, inputValues, dues, feesPay])

  
  const transportFacilityNotAvailable = studentOldDetails && studentOldDetails.status?.TransportFacility === 'No' && !recordInserted;

 

  

  const getCurrePayment = (event) => {
    event.preventDefault();
    setCurrentPayment(event.target.value)
  }

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }


  return (
    <>
      <TabContext value={currentTab.toString()}>
        <PageContainer title="Transport">
          <Grid container>
            <Grid item lg={1} md={1} sm={12} xs={12}>
              <Tabs orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{ borderRight: 1, borderColor: 'divider' }}
              >
                <Tab label="Enroll Student" {...a11yProps(0)} />
                <Tab label="Receive Fees" {...a11yProps(1)} /> {}
                <Tab label="Stop Transport Service" {...a11yProps(2)} />
                <Tab label="All Student (Transport)" {...a11yProps(3)} />
                <Tab label="Defaulters (Transport)" {...a11yProps(4)} />
              </Tabs>
            </Grid>
            <Grid item lg={value !== 3 && value !== 4 ? 6 : 10} md={value !== 3 && value !== 4 ? 6 : 10} sm={12} xs={12}>
              <Box>
                {value !== 3 && value != 4 ? 
                <SuggestionInput
                  handleInputChange={suggestionhandleInputChange}
                  Suggestions={suggestions}
                  placeholder='Roll No / Name'
                  name='RollNum'
                  disabled={value === 3}
                />
                : null}
                <TabPanel value={value} index={0}>
                   <EnrollStudent studentDetails= {studentOldDetails}/>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <ReceiveFees studentDetails= {studentOldDetails}/>
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <StopTransport studentDetails={studentOldDetails} />
                </TabPanel>
                <TabPanel value={value} index={3}>
                  <AllTransport />
                </TabPanel>
                <TabPanel value={value} index={4}>
                  <DefaulterTransportStudents />
                </TabPanel>

              </Box>
            </Grid>
            {value !== 3 && value !== 4 ?
            <Grid item lg={5} md={5} sm={12} xs={12}>
              {
                studentOldDetails && (
                  <StudentDetailsComp data={studentOldDetails.StudentDetails} />
                )
              }
            </Grid>
             :null}
          </Grid>
          {/* <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 224 }}>
{
                        studentOldDetails && studentOldDetails?.result.length != 0 && studentOldDetails?.result != null && studentOldDetails?.result != undefined  ?
                        <CustomTable data={studentOldDetails?.result} />            
                        :
                        null
                    }
          </Box> */}
        </PageContainer>
      </TabContext>
    </>

  );
}

TransportAddRemove.propTypes = {}

export default TransportAddRemove